import React, { useEffect } from 'react';
import { Container, Typography, CircularProgress, Box } from '@mui/material';
import toast from 'react-hot-toast';

const Success: React.FC = () => {
  useEffect(() => {
    toast.success('🎉 Payment successful! Premium activated');

    // ⏳ wait for webhook + UX
    setTimeout(() => {
      // 🔥 FORCE full refresh so premium status updates
      window.location.href = '/app/dashboard';
    }, 2500);
  }, []);

  return (
    <Container maxWidth="sm">
      <Box sx={{ textAlign: 'center', mt: 10 }}>
        <CircularProgress />
        <Typography variant="h5" sx={{ mt: 3 }}>
          Activating your Premium...
        </Typography>
        <Typography variant="body2" sx={{ mt: 2 }}>
          Please wait, we're upgrading your account.
        </Typography>
      </Box>
    </Container>
  );
};

export default Success;